<!-- O modal não tem slot de conteúdo livre: a lista vai no slot "description". -->
<vivest-modal
  heading="Adicionar benefício"
  [hasIcon]="false"
  open
  dismissible
  (vivest-close)="fechar.emit()"
  data-testid="beneficios-modal"
>
  <div slot="description" class="beneficios-modal">
    <p class="beneficios-modal__descricao">
      Os benefícios escolhidos entram no plano ativos, com as regras de elegibilidade em branco para preencher.
    </p>

    @if (carregando()) {
      <p class="beneficios-modal__descricao" data-testid="beneficios-modal-carregando">Carregando benefícios…</p>
    } @else {
      <ul class="beneficios-modal__itens">
        @for (opcao of opcoes(); track opcao.id) {
          <li class="beneficios-modal__item">
            <vivest-checkbox
              class="beneficios-modal__opcao"
              label-variant="multi-line"
              name="beneficios-disponiveis"
              [value]="opcao.id"
              [checked]="jaIncluido(opcao) || selecionados().has(opcao.id)"
              [disabled]="jaIncluido(opcao)"
              (change)="alternar(opcao)"
              [attr.data-testid]="'beneficios-modal-opcao-' + opcao.id"
            >
              {{ opcao.nome }}
            </vivest-checkbox>
            @if (jaIncluido(opcao)) {
              <span class="beneficios-modal__tag">Já incluído</span>
            }
          </li>
        } @empty {
          <li class="beneficios-modal__descricao" data-testid="beneficios-modal-vazio">Nenhum benefício disponível.</li>
        }
      </ul>
    }
  </div>

  <vivest-button slot="actions" variant="outline" size="md" data-testid="beneficios-modal-cancelar" (click)="fechar.emit()">
    Cancelar
  </vivest-button>
  <vivest-button
    slot="actions"
    variant="primary"
    size="md"
    [disabled]="totalSelecionado() === 0"
    data-testid="beneficios-modal-adicionar"
    (click)="confirmar()"
  >
    {{ totalSelecionado() > 0 ? 'Adicionar (' + totalSelecionado() + ')' : 'Adicionar' }}
  </vivest-button>
</vivest-modal>
